document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-countdown]').forEach(function (element) {
    var finish = new Date(element.dataset.countdown).getTime();
    function render() {
      var distance = Math.max(0, finish - Date.now());
      var units = { days: 86400000, hours: 3600000, minutes: 60000, seconds: 1000 };
      Object.keys(units).forEach(function (unit) {
        var value = Math.floor(distance / units[unit]);
        distance %= units[unit];
        var target = element.querySelector('[data-' + unit + ']');
        if (target) target.textContent = String(value).padStart(2, '0');
      });
    }
    render(); setInterval(render, 1000);
  });
  var popup = document.querySelector('[data-holiday-popup]');
  if (popup && !sessionStorage.getItem('holiday-popup-closed')) {
    setTimeout(function () { popup.hidden = false; }, 900);
    popup.querySelector('[data-popup-close]').addEventListener('click', function () {
      popup.hidden = true; sessionStorage.setItem('holiday-popup-closed', '1');
    });
  }
});
